import { oneOf } from 'prop-types';

export default oneOf(['ok', 'warning', 'disconnected']);



// WEBPACK FOOTER //
// ./src/propTypes/deviceStatus.js